












































import _ from 'lodash';
import {
  computed,
  defineComponent,
  nextTick,
  reactive,
  ref,
  watch,
  getCurrentInstance,
  ComponentInternalInstance,
} from '@vue/composition-api';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import i18n, { i18n_t } from '@/locales/i18n';
export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    createDocumentType: {
      required: true,
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const { fileNameMaxLength } = ConstantConfig;
    // 文档的长度要减去.docx5个字符的长度
    const documentNameMaxLength = fileNameMaxLength - 5;
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const name = ref('');
    const createInfo = reactive({
      title: '',
      suffix: '',
    });
    const validateShow = ref(false);
    const validateTip = ref('');
    const createMode = ref('create');
    const methods = {
      submit() {
        if (validateShow.value || !name.value.trim()) return;
        let fromTemplate = 'word.docx';
        switch (props.createDocumentType) {
          case 'create_word':
            fromTemplate = 'word.docx';
            break;
          case 'create_excel':
            fromTemplate = 'excel.xlsx';
            break;
          case 'create_ppt':
            fromTemplate = 'powerpoint.pptx';
            break;
          default:
            break;
        }
        context.emit('onSubmit', {
          name: (name.value + createInfo.suffix).trim(),
          fromTemplate,
          createMode: createMode.value,
        });
      },
    };
    const validateName = (name: string) => {
      // 此处195是因为文件后缀名占用5个长度
      if ((name + createInfo.suffix).trim().length > fileNameMaxLength) {
        validateShow.value = true;
        validateTip.value = i18n_t('名称长度需控制在 {slot1} 字以内', { slot1: documentNameMaxLength });
      } else if (name.indexOf('/') !== -1) {
        validateShow.value = true;
        validateTip.value = i18n_t('名称不支持字符“/”');
      } else if (name.trim() === '') {
        validateShow.value = true;
        validateTip.value = i18n_t('名称不能为空');
      } else {
        validateShow.value = false;
      }
    };
    const throttleValidate = _.throttle(validateName, 500);
    watch(innerShow, val => {
      if (val) {
        switch (props.createDocumentType) {
          case 'create_word':
            createInfo.title = i18n_t('新建 Word 文档');
            createInfo.suffix = '.docx';
            name.value = i18n_t('新建 Word 文档');
            break;
          case 'create_excel':
            createInfo.title = i18n_t('新建 Excel 表格');
            createInfo.suffix = '.xlsx';
            name.value = i18n_t('新建 Excel 表格');
            break;
          case 'create_ppt':
            createInfo.title = i18n_t('新建 PowerPoint 幻灯片');
            createInfo.suffix = '.pptx';
            name.value = i18n_t('新建 PowerPoint 幻灯片');
            break;
          default:
            break;
        }
        nextTick(() => {
          const { createDocInput }: any = (currComponent as ComponentInternalInstance).refs;
          const inputDom = createDocInput?.$el.children[0]?.children[0] as HTMLInputElement;
          inputDom && inputDom?.select();
        });
      }
    });
    return {
      innerShow,
      validateShow,
      validateName,
      throttleValidate,
      validateTip,
      createInfo,
      name,
      createMode,
      documentNameMaxLength,
      ...methods,
    };
  },
});
